import React from "react";
import { FiSearch } from "react-icons/fi";
import { WordTitle } from "../../../../utils/commonFunction";
import Table from "../../../../components/table/table";
import { PatientSearchState, PatientSearchActions } from "../types";

interface PatientResultsTableProps {
  state: PatientSearchState;
  actions: PatientSearchActions;
}

const PatientResultsTable: React.FC<PatientResultsTableProps> = ({
  state,
  actions,
}) => {
  const {
    searchInitiated,
    selectedPatient,
    searchError,
    patientSearchLoader,
    patientResults,
    patientPage,
    patientTotalPages,
    patientTotalCount,
  } = state;

  const { setSelectedPatient, handleNextPatientPage } = actions;

  if (!searchInitiated || selectedPatient || searchError) return null;

  return (
    <div className="mb-4 bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="p-3 border-b border-gray-100 bg-gray-50">
        <h6 className="text-sm font-semibold text-gray-700">
          {patientSearchLoader
            ? "Searching..."
            : patientTotalCount > 0
            ? `Total filtered patients: ${patientTotalCount}`
            : `No patients match the selected filters`}
        </h6>
      </div>

      {/* No Results */}
      {!patientSearchLoader && patientResults?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 px-4">
          <FiSearch className="text-gray-300 mb-3" size={40} />
          <p className="text-gray-500 text-sm font-medium">
            No patients found
          </p>
          <p className="text-gray-400 text-xs mt-1">
            Try adjusting your search or filters
          </p>
        </div>
      ) : (
        <Table
          loading={patientSearchLoader}
          data={patientResults}
          tableScroll={"100%"}
          Clickable={false}
          hasNextPage={patientPage < patientTotalPages}
          NextPageData={handleNextPatientPage}
          columns={["Name", "DOB", "Gender", "Locations", "Status", "Action"]}
          sort={false}
          scopedSlots={{
            Name: ({ row }: any) => (
              <td title={`${row?.lastName}, ${row?.firstName}`}>
                <div className="max-w-[200px] truncate">
                  {row?.lastName}, {row?.firstName}
                </div>
              </td>
            ),
            DOB: ({ row }: any) => (
              <td title={row?.birthDate || ""}>
                <div className="max-w-[120px] truncate">
                  {row?.birthDate || ""}
                </div>
              </td>
            ),
            Gender: ({ row }: any) => (
              <td title={row?.gender || ""}>
                <div className="max-w-[100px] truncate">
                  {WordTitle(row?.gender || "")}
                </div>
              </td>
            ),
            Locations: ({ row }: any) => (
              <td title={row?.location || ""}>
                <div className="max-w-[200px] truncate">
                  {row?.location || ""}
                </div>
              </td>
            ),
            Status: ({ row }: any) => (
              <td title={row?.patientStatus || ""}>
                <div className="max-w-[100px] truncate">
                  {row?.patientStatus || ""}
                </div>
              </td>
            ),
            Action: ({ row }: any) => (
              <td>
                <div className="flex items-center justify-center">
                  <button
                    onClick={() => setSelectedPatient(row)}
                    className="px-3 py-1.5 text-xs font-semibold text-white bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md"
                  >
                    View
                  </button>
                </div>
              </td>
            ),
          }}
        />
      )}
    </div>
  );
};

export default PatientResultsTable;